import React, { useContext, useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import { Grid } from '@mui/material';
import { ECCommonErrorBlock } from '@/components/Forms/ECCommonErrorBlock';
import { ECTextField } from '@/components/Forms/ECTextField';
import { ECPhotoField } from '@/components/Forms/ECPhotoField';
import { ECCheckboxField } from '@/components/Forms/ECCheckboxField';
import Button from '@mui/material/Button';
import { ECSelectField } from '@/components/Forms/ECSelectField';
import { fieldKey } from '../../VisitorList/components/ImportXLS/import_utils';
import { MeetupContext } from '@/MeetupContext';
import Paper from '@mui/material/Paper';
import { ECQuillEditor } from '@/components/Forms/ECQuillEditor';
import { AttachmentsList } from '../../OnlineRegistration/components/AttachmentsList';
const PREFIX = 'MerchEditForm';

const classes = {
  editor: `${PREFIX}-editor`,
  spacing: `${PREFIX}-spacing`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.editor}`]: {
    '& .ql-editor': {
      height: 200,
    },
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },

  [`& .${classes.spacing}`]: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

const MerchEditForm = props => {
  const { form, initial } = props;
  const meetupContext = useContext(MeetupContext);

  const tweakProfile = form.watch('handling.tweakProfile');
  const sendMail = form.watch('handling.sendMail');

  return (
    <Root>
      <ECCommonErrorBlock form={form} />
      <Grid container spacing={3}>
        <Grid size={3}>
          <ECPhotoField label='Изображение' name='imageId' form={form} initial={initial} height={197} />
        </Grid>
        <Grid size={9}>
          <Grid size={12}>
            <ECTextField label='Название' name='name' initial={initial} form={form} />
          </Grid>
          <Grid size={12}>
            <ECTextField label='Стоимость' name='price' initial={initial} defaultValue={0} form={form} />
          </Grid>
          <Grid size={12}>
            <ECTextField label='Описание' name='description' initial={initial} form={form} multiline rows={3} />
          </Grid>
        </Grid>
        <Grid size={3}>
          <ECCheckboxField label='Менять профиль' name='handling.tweakProfile' form={form} initial={initial} />
        </Grid>
        <Grid size={5}>
          <ECSelectField
            label='Поле'
            name='handling.fieldName'
            options={meetupContext.fields}
            form={form}
            initial={initial}
            disabled={!tweakProfile}
            fid={f => fieldKey(f)}
            fname={f => f.label}
          />
        </Grid>
        <Grid size={4}>
          <ECTextField
            label='Значение'
            name='handling.fieldValue'
            form={form}
            initial={initial}
            disabled={!tweakProfile}
          />
        </Grid>

        <Grid size={3}>
          <ECCheckboxField label='Отправлять письмо' name='handling.sendMail' form={form} initial={initial} />
        </Grid>
        <Grid container size={9}>
          {/*<Button>Настроить шаблон</Button>*/}

          <Grid size={12}>
            <ECTextField
              label='Заголовок письма'
              name='handling.mailTemplate.title'
              initial={initial}
              form={form}
              disabled={!sendMail}
              defaultValue={'Товар куплен'}
            />
          </Grid>
          {sendMail && (
            <>
              <Grid size={12}>
                <Paper variant='outlined'>
                  <ECQuillEditor
                    label='Содержание письма'
                    name='handling.mailTemplate.body'
                    initial={initial}
                    form={form}
                    className={classes.editor}
                    disabled={!sendMail}
                    defaultValue={'Вы купили товар'}
                  />
                </Paper>
              </Grid>
              <Grid className={classes.spacing} size={12}>
                <AttachmentsList initial={initial} form={form} name='handling.mailTemplate.attachments' />
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
    </Root>
  );
};

export default MerchEditForm;
